<template>
	<div>
		<div v-if="tab.id === value">
			<slot></slot>
		</div>
	</div>
</template>

<script>
import Tab from '@/types/Tab'

export default {
	props: {
		tab: Tab,
		value: [String, Number],
	},
}
</script>
